function menu_open() {
    $('.burger_button-js').click(function(){
        $(this).toggleClass('opened');
        $('body').toggleClass('menu_burger_open');
        return false;
    });

    // Ferme le menu mobile au clic sur un lien du menu principal
    $('.main-navigation .primary-menu > li:not(.menu-item-has-children) > a').click(function(){
        $('.burger_button-js').removeClass('opened');
        $('body').removeClass('menu_burger_open');
    });
};

function initSmoothScroll() {
    const header = document.querySelector('header');

    function checkScroll() {
        const scrollPosition = window.scrollY;
        if (scrollPosition > 50) {
            header.classList.add('scrolled-js');
        } else {
            header.classList.remove('scrolled-js');
        }
    }

    // Vérifie au chargement
    checkScroll();

    // Vérifie à chaque scroll
    window.addEventListener('scroll', checkScroll);
};

function showMore() {
    const buttons = document.querySelectorAll('.values_item_button-js');
    buttons.forEach(button => {
        button.addEventListener('click', function(e) {
            e.preventDefault();

            const parentLink = button.closest('.values_item');
            if (parentLink) {
                parentLink.classList.add('active');
            }
        });
    });
};

function initCircleSlider(swiperSelector, paginationSelector) {
    new Swiper(swiperSelector, {
        loop: true,
        grabCursor: true,
        centeredSlides: false,
        centeredSlidesBounds: true,
        pagination: { 
            el: paginationSelector,
            clickable: true,
        },
        // navigation: {
        //     nextEl: ".circle_slider__control--next",
        //     prevEl: ".circle_slider__control--prev"
        // },
        slidesPerView: 3,
        effect: "creative",
        creativeEffect: {
            perspective: true,
            limitProgress: 3,
            prev: {
                translate: ["-90%", "20%", -100],
                rotate: [0, 0, -20],
                origin: "bottom"
            },
            next: {
                translate: ["90%", "20%", -100],
                rotate: [0, 0, 20],
                origin: "bottom"
            }
        }
    });
};

function initServiceGallery() {
    document.querySelectorAll('.service_single_gallery-js').forEach(function(swiperContainer) {
        const wrapper = swiperContainer.closest('.service_single_gallery');
        new Swiper(swiperContainer, {
            loop: true,
            slidesPerView: 1,
            spaceBetween: 0,
            navigation: {
                prevEl: wrapper.querySelector('.service_single_gallery_prev-js'),
                nextEl: wrapper.querySelector('.service_single_gallery_next-js'),
            },
        });
    });
};

doAnimations = function () {
    var n = $(window).scrollTop() + $(window).height(),
        e = $(".animatable-js");
    0 == e.length && $(window).off("scroll", doAnimations),
        e.each(function (e) {
            var t = $(this);
            t.offset().top + t.height() - 20 < n && t.removeClass("animatable-js").addClass("animated-js");
    });
};

function removeAnimationFirst() {
    const banners = document.querySelectorAll('.banner');

    banners.forEach(banner => {
        const nextElement = banner.nextElementSibling;

        if (nextElement && (nextElement.tagName === 'DIV' || nextElement.tagName === 'SECTION')) {
            // Sélectionne tous les éléments qui ont au moins une classe animatable
            const animatables = nextElement.querySelectorAll('[class*="animatable-"], .animatable-js');

            animatables.forEach(el => {
                // Copie les classes dans un tableau pour éviter les problèmes en supprimant en boucle
                Array.from(el.classList).forEach(cls => {
                    if (cls === 'animatable-js' || cls.startsWith('animatable-')) {
                    el.classList.remove(cls);
                    }
                });
            });
        }
    });
}

function postsFitler() {
    const buttons = document.querySelectorAll('.post_filter_btn-js');
    const posts = document.querySelectorAll('.post_link-js');
    const fadeDuration = 350; // doit correspondre à la transition CSS de .post_link-js

    buttons.forEach(btn => {
        btn.addEventListener('click', () => {
            buttons.forEach(b => b.classList.remove('active'));
            btn.classList.add('active');

            const filter = btn.dataset.filter;

            posts.forEach(p => {
                const shouldShow = filter === 'all' || p.classList.contains(filter);

                if (shouldShow) {
                    // Réapparition : on affiche d'abord (display), puis on déclenche le fondu
                    // au frame suivant pour laisser la transition s'appliquer.
                    p.classList.add('post_active-js');
                    requestAnimationFrame(() => {
                        requestAnimationFrame(() => {
                            p.classList.add('post_visible-js');
                        });
                    });
                } else if (p.classList.contains('post_visible-js')) {
                    // Disparition : on lance le fondu, puis on retire du flux une fois terminé.
                    p.classList.remove('post_visible-js');
                    setTimeout(() => {
                        p.classList.remove('post_active-js');
                    }, fadeDuration);
                }
            });
        });
    });
};

document.addEventListener("DOMContentLoaded", () => {
    menu_open();
    initSmoothScroll();
    showMore();
    postsFitler();
    removeAnimationFirst();
    initServiceGallery();

    // Initialisation des deux sliders
    initCircleSlider(".team_circle_slider__swiper-js", ".team_circle_slider__pagination-js");
    initCircleSlider(".testimonials_circle_slider__swiper-js", ".testimonials_circle_slider__pagination-js");
});
$(window).on("scroll", function () {
    doAnimations()
})